export const createSubscription = `
    mutation createSubscription($input: CreateSubscriptionInput!) {
        createSubscription(input:$input) {
            id
            customerId
            items {
                id
              }
            description
            currency
            status
        }
}`;

export const updateSubscription = `
    mutation updateSubscription($input: UpdateSubscriptionInput!) {
        updateSubscription(input:$input){
            id
            customerId
            items {
                id
              }
            description
            currency
            status
        }
}`;

export const deleteSubscription = `
    mutation deleteSubscription($input: DeleteSubscriptionInput!) {
        deleteSubscription(input:$input) 
}`;
